import { Validator, NG_VALIDATORS, UntypedFormControl } from '@angular/forms';
import { Directive } from '@angular/core';
import isVarName from 'is-valid-var-name';

@Directive({
  selector: '[datexCommonValidNameValidator]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: ValidNameValidatorDirective, multi: true }
  ],
  standalone: false
})
export class ValidNameValidatorDirective implements Validator {

  public static validator(c: UntypedFormControl) {
    const value: string = c.value;
    const isValid = isVarName(value);
    if (isValid && !value?.includes('$') && !value?.includes('___')) {
      return null;
    } else {
      return { name: true };
    }
  }

  validate(c: UntypedFormControl) {
    return ValidNameValidatorDirective.validator(c);
  }
}

